export default __webpack_public_path__ + "static/media/beeoutofbox.9f29dce7.gif";